import React from "react";
import { Navigate } from "react-router-dom";

// HotelCrm

import ManageServices from "../pages/HotelCRM/ManageServices";
import Reservation from "../pages/HotelCRM/Reservtion/Reservation";
import ManageTask from "../pages/HotelCRM/Manage Task/ManageTask";
import ServiceRequest from "../pages/HotelCRM/Request/ServiceRequest";
import TeamMembers from "../pages/HotelCRM/Team/TeamMembers";
import HousekeepingDashboard from "../pages/HotelCRM/Housekeeping/HousekeepingDashboard";
///////guest Portal

import GuestFoodOrder from "../pages/HotelCRM/GuestPortal/GuestFoodOrder";
import GuestHousekeeping from "../pages/HotelCRM/GuestPortal/GuestHousekeeping";
import HousekeepingTaskPage from "../pages/HotelCRM/Housekeeping/HousekeepingTaskPage";

/////
// import ManageRooms from "../pages/HotelCRM/ManageServices/Rooms";
import Checkout from "../pages/HotelCRM/Checkout/Checkout";
import AdminEmergencyRequests from "../pages/HotelCRM/ManageBookings/Emmergency";
import ManageOrders from "../pages/HotelCRM/FoodOrder/ManageOrder";
import CreateOrder from "../pages/HotelCRM/FoodOrder/CreateOrder";
// Auth
import Login from "../pages/Authentication/Login";
import AdminComplaints from "../pages/HotelCRM/Complaints/complaints";
import ChangePassword from "../pages/Authentication/ChangePassword";
import DashboardCrm from "../pages/HotelCRM/DashboardCRM";
import BookingsDashboard from "../pages/HotelCRM/ManageBookings/Spa/BookingsDashboard";
import Dashboard from "../pages/HotelCRM/ManageBookings/Spa/BookingsDashboard";
import ChannelDashboard from "../pages/ChannelManager/DashboardCM";
import InventoryManagement from "../pages/ChannelManager/Inventory";
import RatesManagement from "../pages/ChannelManager/Rates";
import RestrictionsManagement from "../pages/ChannelManager/Restrictions";
import RoomMapping from "../pages/ChannelManager/RoomMapping";
import SyncLogs from "../pages/ChannelManager/SyncLogs";
import BookingLogs from "../pages/ChannelManager/BooingLogs";
import Channels from "../pages/ChannelManager/Channels";
import ChannelSettings from "../pages/ChannelManager/Settings";
import ChefOrderPage from "../pages/HotelCRM/ManageBookings/ChefOrderPage";
import ManageRoomTypes from "../pages/HotelCRM/RoomManagement/ManageRoomType";
import ManageRooms from "../pages/HotelCRM/RoomManagement/ManageRoom";
import GuestPortal from "../pages/HotelCRM/GuestPortal";
import MyProfile from "../pages/HotelCRM/Settings/MyProfile";
import RevenueDashboard from "../pages/HotelCRM/Revenue";
import { components } from "react-select";
// import DashboardCrm from "../pages/DashboardCrm";
import StatementDownload from "../pages/HotelCRM/Reports/StatementDownload";
import InvoicePage from "../pages/HotelCRM/Invoice/InvoicePage";
import MenuBuilder from "../pages/RMS/MenuBuilder";
import SSOLogin from "../pages/Authentication/SSOLogin";
import TaxiServices from "../pages/HotelCRM/TaxiManageent/TaxiServices";


// 🔐 Auth protected routes
const authProtectedRoutes = [
  { path: "/dashboard", component: <DashboardCrm /> },
  { path: "/housekeeping-dashboard", component: <HousekeepingDashboard /> },
  { path: "/manage-orders", component: <ManageOrders /> },
  { path: "/create-order", component: <CreateOrder /> },
  { path: "/services", component: <ManageServices /> },
  { path: "/spa-dashboard", component: <BookingsDashboard /> },
  { path: "/reservation", component: <Reservation /> },
  // { path: "/setting-services", component: <Settings /> },
  { path: "/service-request", component: <ServiceRequest /> },
  { path: "/team", component: <TeamMembers /> },
  { path: "/task", component: <ManageTask /> },
  { path: "/checkout", component: <Checkout /> },
  { path: "/room-types", component: <ManageRoomTypes /> },
  { path: "/manage-room", component: <ManageRooms /> },
  { path: "/health", component: <AdminEmergencyRequests /> },
  { path: "/complaints", component: <AdminComplaints /> },
  { path: "/profile", component: <MyProfile /> },
{ path: "/revenue", component: <RevenueDashboard /> },
{ path: "/report",  component: <StatementDownload/> },
{ path: "/taxi-management",  component: <TaxiServices/> },



// /////////////////////////////////////////////////////////

// RMS

// /////////////////////////////////////////////////////////

 { path: "/menu-builder", component: <MenuBuilder /> },


  //// channel Manager 

  {
    path: "/channel-manager/dashboard",
    component: <ChannelDashboard />,
  },
  {
    path: "/channel-manager/inventory",
    component: <InventoryManagement />,
  },

  {
    path: "/channel-manager/rates",
    component: <RatesManagement />,
  },

  {
    path: "/channel-manager/restrictions",
    component: <RestrictionsManagement />,
  },
  {
    path: "/channel-manager/room-mapping",
    component: <RoomMapping />,
  },

  {
    path: "/channel-manager/sync-logs",
    component: <SyncLogs />,
  },
  {
    path: "/channel-manager/booking-logs",
    component: <BookingLogs />,
  },
  {
    path: "/channel-manager/channels",
    component: <Channels />,
  },

  {
    path: "/channel-manager/settings",
    component: <ChannelSettings />,
  },

  // Defaults → redirect to login instead of reservation
  { path: "/", component: <Navigate to="/sso" /> },
  { path: "*", component: <Navigate to="/sso" /> },
];

// ///////////////////////////////////////////////////////////////////
// RMS
// //////////////////////////////////////////////////////////////////


// 🌍 Public routes
const publicRoutes = [
  { path: "/login", component: <Login /> },
    { path: "/sso", component: <SSOLogin /> },
  { path: "/change-password", component: <ChangePassword /> },

  {
    path: "/guest-portal/:tenantId/:roomNumber",
    component: <GuestPortal />,
  },
    {
    path: "/invoice/:bookingId",
    component: <InvoicePage />,
  },

  {
    path: "/guest-portal/:tenantId/:roomNumber/food",
    component: <GuestFoodOrder />,
  },

  {
    path: "/guest-portal/:tenantId/:roomNumber/housekeeping",
    component: <GuestHousekeeping />,
  },
  {
    path: "/housekeeping/task/:requestId",
    component: <HousekeepingTaskPage />
  },

  {
    path: "/housekeeping-task/:taskId",
    component: <HousekeepingTaskPage />
  },


  {
    path: "/chef-order/:orderId",
    component: <ChefOrderPage />
  },
];

export { authProtectedRoutes, publicRoutes };
